<template>
  <v-dialog v-model="showModal" width="850">
    <v-card>
      <v-card-title class="modal-header">
        Detalle de Compra código por cliente
        <v-icon class="close-icon" @click="showModal = false"
          >mdi-close-circle</v-icon
        >
      </v-card-title>

      <v-card-text class="text-left p-4">
        <div class="modal-title mb-5">
          <p class="mb-0">
            <b>Mes {{ month }} {{ material.date.year }}</b>
          </p>
          <p class="mb-0">
            <b>{{
              `${Number.parseInt(material.material.MATNR)} 
              ${material.material.ARKTX} 
              Unidad de medida: ${material.material.MEINS}`
            }}</b>
          </p>
        </div>

        <v-data-table
          :headers="headers"
          :items="processedCustomers"
          :mobile-breakpoint="null"
          :loading="loading"
          class="elevation-2 table__desing-general"
        >
          <template #header>
            <tfoot>
              <tr>
                <td>Total</td>
                <td></td>
                <td></td>
                <td>{{ totalQuantity }}</td>
                <td>${{ totalAmount | removeDecimals }}</td>
                <td>{{ customers.length > 0 ? 100 : 0 }}%</td>
              </tr>
            </tfoot>
          </template>

          <template #[`item.KUNAG`]="{ item }">
            {{ parseInt(item.KUNAG) }}
          </template>

          <template #[`item.IMPORTE`]="{ item }">
            ${{ item.IMPORTE | removeDecimals }}
          </template>

          <template #[`item.PORCENTAJE`]="{ item }">
            {{ item.porcentage | removeDecimals }}%
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import moment from 'moment';
  import axios from '@/plugins/axios';
  import { mapGetters } from 'vuex';
  export default {
    props: {
      value: Boolean,
      material: {
        type: Object,
        required: true,
      },
      typeRole: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
        customers: [],
        headers: [
          { text: 'N°', value: 'id', align: 'center' },
          { text: 'Cliente', value: 'KUNAG', align: 'center' },
          { text: 'Razón Social', value: 'NAME1', align: 'center' },
          { text: 'Unidades', value: 'UNIDADES', align: 'center' },
          { text: 'Importe', value: 'IMPORTE', align: 'center' },
          { text: '%', value: 'PORCENTAJE', align: 'center' },
        ],
      };
    },
    computed: {
      showModal: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
      totalQuantity() {
        return this.customers.reduce(
          (acc, customer) => acc + parseInt(customer.UNIDADES),
          0
        );
      },
      totalAmount() {
        return this.customers.reduce(
          (acc, customer) => acc + parseFloat(customer.IMPORTE),
          0
        );
      },
      month() {
        return moment()
          .month(this.material.date.month - 1)
          .format('MMMM');
      },
      processedCustomers() {
        return [...this.customers]
          .sort((a, b) => b.UNIDADES - a.UNIDADES)
          .map((customer, index) => ({
            ...customer,
            porcentage: (customer.IMPORTE * 100) / this.totalAmount,
            id: index + 1,
          }));
      },
      ...mapGetters({
        user: 'auth/user',
      }),
    },
    watch: {
      showModal(newValue) {
        if (newValue) {
          this.getMaterialDetails();
        }
      },
    },
    methods: {
      async getMaterialDetails() {
        this.customers = [];
        this.loading = true;

        try {
          const response = await axios.get(
            '/renglonaje-by-family/material-details',
            {
              params: {
                CLAVE: this.typeRole.code,
                TIPO: this.typeRole.letter,
                MATNR: Number.parseInt(this.material.material.MATNR),
                SPMON: `${this.material.date.year}${String(
                  this.material.date.month
                ).padStart(2, '0')}`,
                VTWEG: this.user.VTWEG,
              },
            }
          );
          this.customers = response.data.data;
        } catch {
          this.$toast.error('Error al obtener los clientes');
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
  .modal-header {
    background: #000 !important;
    color: #fff;
    font-size: 12px !important;
    display: flex;
    justify-content: space-between;
    line-height: auto !important;
    padding: 5px 10px !important;
  }

  .modal-header .v-icon {
    color: #fff;
  }

  tfoot {
    background: #f2f2f2;
    text-align: center;
    font-weight: bold;
  }

  .modal-title {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
    opacity: 1;
    text-align: center;
    padding: 8px;
    border-bottom: 4px solid #c50000;
    font-size: 14px;
  }
</style>
